import React, { useLayoutEffect } from "react";
import { Route, Switch, Redirect } from "react-router";
import AdminPage from "./pages/AdminPage";
import LogInPage from "./pages/LogInPage";
import { MainContainer } from "./styles/genericStyles";
import { useDispatch, useSelector } from "react-redux";
import { isAuthenticated, isUserAuthenticated } from "./redux/slices/userSlice";
import Loader from "./components/generic/Loader";

const App = () => {
  const authenticated = useSelector((state) => isUserAuthenticated(state));
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(isAuthenticated());
  }, [dispatch]);

  if (authenticated === undefined) return <Loader />;

  return (
    <MainContainer>
      {!authenticated && <Redirect to="/login" />}
      <Switch>
        <Route exact path="/login">
          <LogInPage />
        </Route>
        <Route path="/admin" component={AdminPage} />
        <Route path="*">
          <LogInPage />
        </Route>
      </Switch>
    </MainContainer>
  );
};

export default App;
